<template>
  <v-hover v-slot="{ hover }">
    <v-container>
      <p class="tank-name">{{tankName}}</p>
      <v-card
        width="100%"
        tile
        :elevation="hover ? 15 : 2"
        hover
        @click="clickAction"
        color="rgba(255,255,255,0)"
        flat
        class="tank-card"
      >
        <v-img min-height="200" max-height="200" width="100%" :src="imageUrl" class="tank-image"></v-img>
      </v-card>
    </v-container>
  </v-hover>
</template>

<script>
export default {
  name: "OtherTeamTank",
  data: () => ({}),
  methods: {
    clickAction() {
      this.$emit('clickAction');
    }
  },
  props:['tankName', 'imageUrl']
};
</script>

<style scoped>
.tank-name {
  color: #fff;
  font-size: 1.5em;
}
.tank-card {
  border-radius: 30px !important;
}
.tank-image {
  border-radius: 30px !important;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
